import { useMutation, useQuery } from "@tanstack/react-query";

import {
  PostSetupFacebookConversionAPI,
  GetConversionApiData,
  GetApiKey,
  GetApiKeyById,
  PostApiKey,
  DeleteApiKeyById,
  PutApiKeyById,
} from "@/server-types";
import { del, get, post, put } from "../request-helpers";
import { useCustomMutation } from "../custom-mutation";
import { useCustomQuery } from "../custom-query";

export const useGetFacebookConversionApiData = () => {
  return useQuery({
    queryKey: ["getFacebookConversionApiData"],
    queryFn: () =>
      get<GetConversionApiData>("/integration/facebook/conversion-api"),
  });
};

export const usePostSetupFacebookConversionAPI = () => {
  return useMutation({
    mutationKey: ["postSetupFacebookConversionAPI"],
    mutationFn: (body: PostSetupFacebookConversionAPI["body"]) =>
      post<PostSetupFacebookConversionAPI>(
        "/integration/facebook/conversion-api/setup",
        body,
      ),
  });
};

export const useGetApiKeys = () => {
  return useCustomQuery({
    queryKey: ["getApiKeys"],
    queryFn: () => get<GetApiKey>("/api/key"),
  });
};

export const useGetApiKeyById = (id: number) => {
  return useCustomQuery({
    queryKey: ["getApiKeyById", id],
    queryFn: () => get<GetApiKeyById>(`/api/key/${id}`),
    enabled: id !== -1,
    gcTime: 0,
  });
};

export const usePostApiKey = () => {
  return useCustomMutation({
    mutationKey: ["postApiKey"],
    displayNotification: true,
    mutationFn: (body: PostApiKey["body"]) =>
      post<PostApiKey>("/api/key", body),
  });
};

export const useDeleteApiKeyById = (id: number) => {
  return useCustomMutation({
    mutationKey: ["deleteApiKeyById", id],
    mutationFn: () => del<DeleteApiKeyById>(`/api/key/${id}`),
    displayNotification: true,
  });
};

export const usePutApiKeyById = (id: number) => {
  return useCustomMutation({
    mutationKey: ["putApiKeyById", id],
    mutationFn: (body: PutApiKeyById["body"]) =>
      put<PutApiKeyById>(`/api/key/${id}`, body),
  });
};
